import {

  SAVING_SMTP_EMAIL_REQUEST, SAVING_SMTP_EMAIL_SUCCEDDED, SAVING_SMTP_EMAIL_FAILED,
  FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST, FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED, FETCHING_SMTP_EMAIL_INTEGRATION_FAILED,
} from '../../actions/actionTypes.jsx';

import { combineReducers } from 'redux';

const initialState = {
  changes: {
    saving: false,
    error: null
  },
  deactivation: {
    deactivating: false,
    error: null
  }
};

function smtpReducer(state = initialState, action) {
  switch (action.type) {
    case SAVING_SMTP_EMAIL_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: true,
          error: null
        }
      })
    case SAVING_SMTP_EMAIL_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: null
        }
      })
    case SAVING_SMTP_EMAIL_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          saving: false,
          error: action.payload
        }
      })

    case FETCHING_SMTP_EMAIL_INTEGRATION_REQUEST:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: true
        }
      }) 
    case FETCHING_SMTP_EMAIL_INTEGRATION_SUCCEDDED: 
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      }) 
    case FETCHING_SMTP_EMAIL_INTEGRATION_FAILED:
      return Object.assign({}, state, {
        ...state,
        changes: {
          ...state.changes,
          loading: false
        }
      }) 

    default:
      return state
  }
}

export { smtpReducer };